module.exports = __webpack_public_path__ + "img/gb-eng.cadcb1b0.svg";